/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConsumerTaskObjectType,
    ConsumerTaskObjectTypeFromJSON,
    ConsumerTaskObjectTypeFromJSONTyped,
    ConsumerTaskObjectTypeToJSON,
    ConsumerTaskStatus,
    ConsumerTaskStatusFromJSON,
    ConsumerTaskStatusFromJSONTyped,
    ConsumerTaskStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface AutoObjectTask
 */
export interface AutoObjectTask {
    /**
     * 
     * @type {string}
     * @memberof AutoObjectTask
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AutoObjectTask
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof AutoObjectTask
     */
    firmId?: string;
    /**
     * 
     * @type {string}
     * @memberof AutoObjectTask
     */
    referenceId?: string;
    /**
     * 
     * @type {ConsumerTaskObjectType}
     * @memberof AutoObjectTask
     */
    objectType?: ConsumerTaskObjectType;
    /**
     * 
     * @type {ConsumerTaskStatus}
     * @memberof AutoObjectTask
     */
    status?: ConsumerTaskStatus;
    /**
     * 
     * @type {number}
     * @memberof AutoObjectTask
     */
    progressPercentage?: number;
    /**
     * 
     * @type {Date}
     * @memberof AutoObjectTask
     */
    createdDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AutoObjectTask
     */
    modifiedDate?: Date | null;
    /**
     * 
     * @type {any}
     * @memberof AutoObjectTask
     */
    taskData?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AutoObjectTask
     */
    documentId?: string;
}

export function AutoObjectTaskFromJSON(json: any): AutoObjectTask {
    return AutoObjectTaskFromJSONTyped(json, false);
}

export function AutoObjectTaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoObjectTask {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'firmId': !exists(json, 'firmId') ? undefined : json['firmId'],
        'referenceId': !exists(json, 'referenceId') ? undefined : json['referenceId'],
        'objectType': !exists(json, 'objectType') ? undefined : ConsumerTaskObjectTypeFromJSON(json['objectType']),
        'status': !exists(json, 'status') ? undefined : ConsumerTaskStatusFromJSON(json['status']),
        'progressPercentage': !exists(json, 'progressPercentage') ? undefined : json['progressPercentage'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'taskData': !exists(json, 'taskData') ? undefined : json['taskData'],
        'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
    };
}

export function AutoObjectTaskToJSON(value?: AutoObjectTask | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'userId': value.userId,
        'firmId': value.firmId,
        'referenceId': value.referenceId,
        'objectType': ConsumerTaskObjectTypeToJSON(value.objectType),
        'status': ConsumerTaskStatusToJSON(value.status),
        'progressPercentage': value.progressPercentage,
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'modifiedDate': value.modifiedDate === undefined ? undefined : (value.modifiedDate === null ? null : value.modifiedDate.toISOString()),
        'taskData': value.taskData,
        'documentId': value.documentId,
    };
}


